import React, {useEffect, useState} from 'react';
import {Link, useParams} from "react-router-dom";
import AjaxService from "../../platform/ajax/AjaxService";
import {Card} from "../../components/Card";
import {createInternationalizationPrefixer} from "../../platform/i18n/i18n";
import {AuthLanguageSwitcher} from "../account/AuthLanguageSwitcher";

const t = createInternationalizationPrefixer("RegistrationConfirmPage");

const LOADING = "loading";
const FAILED = "failed";

export function RegistrationConfirmPage() {
    const {code} = useParams();
    const [status, setStatus] = useState<string>(LOADING);

    useEffect(() => {
        AjaxService.postJson("/api/registration/confirm/" + code, {})
            .then(response => setStatus((response.json as { status: string }).status))
            .catch(() => setStatus(FAILED));
    }, [code]);

    return <div>
        <div className="account-pages mt-5 mb-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-5">
                        <AuthLanguageSwitcher/>
                        <Card>
                            <ConfirmationHeader/>
                            <ConfirmationBody status={status}/>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer footer-alt text-dark text-center">
            {(new Date().getFullYear())} &copy; Wentech
        </footer>
    </div>;
}

function ConfirmationHeader() {
    return <div className="text-center">
        <div className="clearfix text-center pt-20 pb-20">
            <img src="/img/wentech_logo.svg" width="60%" alt="logo"/>
            <div className="text-muted mt-3">
                <h3>Optisel 2</h3>
                {t("Potwierdzenie adresu e-mail")}
            </div>
        </div>
    </div>;
}

function statusMessage(status: string): string {
    if (status === "confirmed") {
        return t("Twój adres e-mail został potwierdzony. Konto czeka na akceptację administratora.");
    }
    if (status === "alreadyConfirmed") {
        return t("Ten adres e-mail został już wcześniej potwierdzony.");
    }
    if (status === "invalid") {
        return t("Link potwierdzający jest nieprawidłowy lub wygasł.");
    }
    if (status === "emailAlreadyRegistered") {
        return t("Konto dla tego adresu e-mail już istnieje.");
    }
    return t("Wystąpił błąd podczas potwierdzania adresu e-mail.");
}

function ConfirmationBody({status}: { status: string }) {
    if (status === LOADING) {
        return <div className="text-center">...</div>;
    }
    return <div className="text-center">
        <p className="mt-3">{statusMessage(status)}</p>
        <Link to="/sign-in" className="btn btn-link mt-2">{t("Powrót do logowania")}</Link>
    </div>;
}
